import React, { ReactElement } from "react";

/**
 * StackedCard chrome glyphs.
 *
 * These are part of the card's own chrome — they act on the CARD (collapse the
 * cover, remove the cover, resize the card), never on the entity a card
 * represents. They ship with the component rather than coming from the icon
 * collection so a facade never has to re-pick them and every stacked card
 * reads the same.
 */

/** Collapse the cover down to its thin strip. */
export const StackedCardCollapseGlyph = (): ReactElement => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M6.5 2.5v4h-4M9.5 13.5v-4h4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Expand a collapsed cover — the inverse of collapse, shown on the strip. */
export const StackedCardExpandGlyph = (): ReactElement => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M2.5 6.5v-4h4M13.5 9.5v4h-4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Drop the cover entirely. */
export const StackedCardRemoveCoverGlyph = (): ReactElement => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <rect
      x="2.25"
      y="3.75"
      width="11.5"
      height="8.5"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M6 9.5L10 6M10 9.5L6 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

/** The bottom-right resize grip. */
export const StackedCardResizeHandleGlyph = (): ReactElement => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M12 6v6H6M12 9.5L9.5 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
